import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import { compose } from '../core/compose.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const paddingConfig = {
  padding: {
    property: 'padding'
  },
  paddingTop: {
    property: 'paddingTop'
  },
  paddingRight: {
    property: 'paddingRight'
  },
  paddingBottom: {
    property: 'paddingBottom'
  },
  paddingLeft: {
    property: 'paddingLeft'
  },
  paddingBlockStart: {
    property: 'paddingBlockStart'
  },
  paddingBlockEnd: {
    property: 'paddingBlockEnd'
  },
  paddingInlineStart: {
    property: 'paddingInlineStart'
  },
  paddingInlineEnd: {
    property: 'paddingInlineEnd'
  }
};
const paddingShorthandConfig = {};
paddingShorthandConfig.p = paddingConfig.padding;
paddingShorthandConfig.pt = paddingConfig.paddingTop;
paddingShorthandConfig.pr = paddingConfig.paddingRight;
paddingShorthandConfig.pb = paddingConfig.paddingBottom;
paddingShorthandConfig.pl = paddingConfig.paddingLeft;
paddingShorthandConfig.px = {
  properties: ['paddingTop', 'paddingBottom']
};
paddingShorthandConfig.py = {
  properties: ['paddingLeft', 'paddingRight']
};
paddingShorthandConfig.paddingStart = paddingConfig.paddingInlineStart;
paddingShorthandConfig.ps = paddingConfig.paddingInlineStart;
paddingShorthandConfig.paddingEnd = paddingConfig.paddingInlineEnd;
paddingShorthandConfig.pe = paddingConfig.paddingInlineEnd;
const padding = compose(system(paddingConfig), system(paddingShorthandConfig));

export { padding };
